import { convertKitApi } from 'shared/api/requests/integrations/convertKit'
import { createAsyncAction } from 'shared/lib/redux'

export const setAccountLinkField = createAsyncAction(
  'integration/convertKit/setAccountLinkField',
  async ({ field_id, field_name }: { field_id: string | null; field_name: string | null }) => {
    const response = await convertKitApi.setAccountLinkField({ body: { field_id, field_name } })
    return response.data
  },
)

export const clearAccountLinkField = createAsyncAction(
  'integration/convertKit/clearAccountLinkField',
  async () => {
    const response = await convertKitApi.clearAccountLinkField({})
    return response.data
  },
)

export const fetchForms = createAsyncAction('integration/convertKit/fetchForms', async () => {
  const response = await convertKitApi.getForms({})
  return response.data
})

export const fetchSequences = createAsyncAction(
  'integration/convertKit/fetchSequences',
  async () => {
    const response = await convertKitApi.getSequences()
    return response.data
  },
)

export const fetchTags = createAsyncAction('integration/convertKit/fetchTags', async () => {
  const response = await convertKitApi.getTags()
  return response.data
})

export const fetchConvertKitFields = createAsyncAction(
  'integration/convertKit/fetchConvertKitFields',
  async () => {
    const response = await convertKitApi.getFields()
    return response.data
  },
)
